import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';

const redirectURL = process.env.REACT_APP_PORTAL_URL;


const ErrorPage = () => {

  const handlePortalredirect = () => {
    //TODO: Add environment check here hard coded to portal for now.
    window.location.href = redirectURL;
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 8 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h3" color="error" gutterBottom>
          Oops!
        </Typography>
        <Typography variant="h6" color="textSecondary">
          Something went wrong. We couldn't process your request.
        </Typography>
      </Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="body1">
           This content needs to be accessed through the Bankers Portal. Please 
           access the Bankers Portal below and try again.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button variant="contained" color="primary" onClick={handlePortalredirect}>
          Bankers Agent Portal
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorPage;
